const buildTrackingPath = (funnelName, pageName, requestName, eventType, extraPath = '') => {
    if (!funnelName || !pageName || !requestName || !eventType) {
        throw new Error('Required params are missing');
    }

    const safeExtraPath = extraPath && !extraPath.startsWith('.') ? `.${extraPath}` : extraPath;

    return `${funnelName}.${pageName}.${eventType}.${requestName}${safeExtraPath}`;
};

module.exports = {
    buildTrackingPath,
};
